import loadable from "@loadable/component";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../customHooks/usePatchHook";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../../components/Reusable/Spinner";
import usePostHook from "../../customHooks/usePostHook";
import { useEffect, useState } from "react";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { usePDFPrintHook } from "@careinfo/layout";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const EditOrderComponent = loadable(
  () => import("../../components/Consignment/EditConsignment")
);
const EditConsignment = () => {
  const { id } = useParams();
  const [openAddReceiverPopup, setOpenAddReceiverPopup] = useState(false);
  const [openAddSenderPopup, setOpenAddSenderPopup] = useState(false);
  const [openPrintPopup, setOpenPrintPopup] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [prevData, setPrevData] = useState();
  const { data: order, isLoading } = useGetHook({
    queryKey: [`order-${id}`],
    url: `${APIS.ORDER}${id}/`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["order"],
    navigateURL: "",
  });

  const { data: profile } = useGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });

  const { downloadPrint, isPrintLoading } = usePDFPrintHook();
  const handleLabelPrintDownload = async () => {
    const url = `${APIS.ORDER}label-print/`;
    let formData = {
      order_ids: [selectedOrder],
    };
    try {
      await downloadPrint(url, formData);
    } catch (err) {
      console.log(err);
    }
  };

  const handleOrderReceiptDownload = async () => {
    const url = `${APIS.ORDER}order-receipt-print/`;
    let formData = {
      order_ids: [selectedOrder],
    };
    try {
      await downloadPrint(url, formData);
    } catch (err) {
      console.log(err);
    }
  };

  // const logChangesWithFieldMapping = (
  //   newData: any[],
  //   oldData: any[],
  //   oldFields: string[],
  //   newFields: string[]
  // ) => {
  //   const fieldMapping = oldFields.reduce((map, oldField, index) => {
  //     map[oldField] = newFields[index];
  //     return map;
  //   }, {});

  //   const changes: { added: any[]; removed: any[]; updated: any[] } = {
  //     added: [],
  //     removed: [],
  //     updated: [],
  //   };

  //   newData.forEach((newItem, index) => {
  //     const oldItem = oldData[index];

  //     if (!oldItem) {

  //       changes.added.push(newItem);
  //     } else {

  //       oldFields.forEach((oldField) => {
  //         const newField = fieldMapping[oldField];

  //         if (
  //           oldField === "package_type" &&
  //           oldItem.package_type.name !== newItem.package_type.name
  //         ) {
  //           changes.updated.push({
  //             object_id: index,
  //             field_name: oldField,
  //             old_data: oldItem.package_type.name,
  //             new_data: newItem.package_type.name,
  //           });
  //         } else if (
  //           newField &&
  //           JSON.stringify(newItem[newField]) !==
  //             JSON.stringify(oldItem[oldField])
  //         ) {
  //           changes.updated.push({
  //             object_id: index,
  //             field_name: oldField,
  //             old_data: oldItem[oldField],
  //             new_data: newItem[newField],
  //           });
  //         }
  //       });
  //     }
  //   });

  //   oldData.forEach((oldItem, index) => {
  //     if (!newData[index]) {
  //       changes.removed.push({
  //         object_id: index,
  //         item: oldItem,
  //       });
  //     }
  //   });

  //   console.log("Changes with field mapping:", changes);
  // };

  const transformPackageTypeToId = (data: any[]) => {
    return data?.map((item) => ({
      ...item,
      calculated_by: item?.calculated_by?.id,
      package_type: item.package_type.id,
    }));
  };

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.ORDER}${id}/`;
    const formatExtraCharges = (values, prevExtraCharges = {}) => {
      return values?.extra_charges
        ? Object.entries(values.extra_charges)
            .filter(([key, value]) => {
              const prevValue = prevExtraCharges[key] || 0;
              return (
                value !== "" &&
                value !== null &&
                (value !== 0 || prevValue !== 0)
              );
            })
            .map(([key, value]) => ({
              name: key,
              charge: value,
            }))
        : null;
    };
    const prevExtraCharges = order?.extra_charges;
    // console.log("new data ", values?.order_items);

    // console.log("old data", prevData);
    // const OldDatafields = ["package_type", "pieces", "weight", "rate", "note"];
    // const NewDatafields = ["package_type", "piece", "weight", "rate", "remark"];
    // logChangesWithFieldMapping(
    //   values?.order_items || [],
    //   prevData || [],
    //   OldDatafields,
    //   NewDatafields

    const formattedArray = formatExtraCharges(values, prevExtraCharges);
    const transformedData = transformPackageTypeToId(values?.order_items);
    let formData = {
      ...values,
      order_items: transformedData,
      sender_phone_number:
        values?.sender_phone_number?.length === 10
          ? `+977${values?.sender_phone_number}`
          : values?.sender_phone_number
          ? values?.sender_phone_number
          : null,
      receiver_phone_number:
        values?.receiver_phone_number?.length === 10
          ? `+977${values?.receiver_phone_number}`
          : values?.receiver_phone_number
          ? values?.receiver_phone_number
          : null,
      extra_charges: formattedArray,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res.status == 200) {
        setOpenPrintPopup(true);
        setSelectedOrder(id);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (Array.isArray(order?.children)) {
      setPrevData(order?.children);
    }
  }, [order]);

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-4 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Consignment
        </span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <EditOrderComponent
          isLoading={isPatchLoading}
          handleEdit={handleEdit}
          order={order}
          openAddReceiverPopup={openAddReceiverPopup}
          setOpenAddReceiverPopup={setOpenAddReceiverPopup}
          openAddSenderPopup={openAddSenderPopup}
          setOpenAddSenderPopup={setOpenAddSenderPopup}
          openPrintPopup={openPrintPopup}
          setOpenPrintPopup={setOpenPrintPopup}
          profile={profile}
          isPrintLoading={isPrintLoading}
          handleLabelPrintDownload={handleLabelPrintDownload}
          handleOrderReceiptDownload={handleOrderReceiptDownload}
        />
      )}
    </>
  );
};
export default EditConsignment;
